import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import Link from '@activebrands/core-web/components/Link';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import getSelector from '@activebrands/core-web/utils/get-selector';
import Badges from 'components/Badges';
import ThemeButton from 'components/buttons/ThemeButton';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';

const FeaturedItems = ({ $style = {}, items = [], selector }) => {
    const [css] = useStyletron();

    if (!items?.length) {
        return null;
    }

    return (
        <div
            data-selector={selector}
            className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: '8px 0',
                ...$style,
            })}
        >
            {items.map(({ _editable, badgeText = '', badgeTheme = 'primary', label = '', link = {} }) => {
                return (
                    <div className={css({ alignItems: 'flex-start', display: 'flex' })} key={label} {...transformPreviewEditable(_editable)}>
                        <ThemeButton
                            isVolatile
                            data-selector={getSelector(selector, 'item')}
                            theme="link"
                            $style={{
                                padding: '6px 12px',
                            }}
                            fontKeys={['Primary/16_120_-1']}
                            as={Link}
                            to={link.url}
                        >
                            {label}
                        </ThemeButton>
                        {badgeText && badgeTheme && (
                            <Badges
                                $badgesStyles={{
                                    padding: '4px',
                                    borderRadius: '4px',
                                    ...textStyles['Primary/16_120_-1'],
                                }}
                                $style={{
                                    display: 'inline-block',
                                    position: 'relative',
                                    bottom: 'unset',
                                    width: 'auto',
                                }}
                                items={[{ colorTheme: badgeTheme, displayText: badgeText, internalName: badgeText }]}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

FeaturedItems.propTypes = {
    $style: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    selector: PropTypes.string,
};

export default FeaturedItems;
